<template>
  <div>
    <label v-if="label || $slots.label" :for="name" class="input-label">
      <slot name="label" :required="required" :attrs-name="name"
        >{{ label }} <span v-if="required" class="required-input">*</span></slot
      >
    </label>
    <div class="relative">
      <slot
        :is-selected="isSelected"
        :toggle-option="selectOptionIfActive"
        :options="normalizedOptions"
        :disabled="disabled"
        :is-external-selected="isExternalSelected"
      >
        <div :class="['max-w-lg', inline ? 'flex space-x-4' : 'space-y-2']">
          <div
            v-for="option in normalizedOptions"
            :key="option.value"
            class="relative flex items-start"
          >
            <div class="flex items-center h-5">
              <input
                type="radio"
                :checked="isSelected(option)"
                :name="name"
                :value="option.value"
                class="input-radio element-focus"
                :class="{ 'input-radio-checkbox-disabled': disabled }"
                :disabled="disabled"
                @change="selectOptionIfActive(option)"
              />
            </div>
            <div class="ml-3 text-sm">
              <label class="text-gray-700">{{ option.label }}</label>
            </div>
          </div>
        </div>
      </slot>
    </div>
    <p
      v-if="displayedError || help"
      class="mt-1 text-sm"
      :class="{
        'text-gray-500': !displayedError,
        'text-red-600': displayedError,
      }"
    >
      {{ displayedError || help }}
    </p>
  </div>
</template>

<script>
import { useSelect } from 'vue-batteries'
import { useFieldValidation } from '@/api/useValidation'
import { toRefs } from 'vue'

export default {
  name: 'TRadioGroup',
  props: {
    name: {
      type: String,
      default: '',
    },
    validator: {
      type: String,
      default: 'validator',
    },
    label: {
      type: String,
      default: '',
    },
    options: {
      type: [Array, Object],
      required: true,
    },
    modelValue: {
      type: [Number, Boolean, String, Array, Object, null],
      required: true,
    },
    error: {
      type: [String, Array],
      default: '',
    },
    help: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const { modelValue, options } = toRefs(props)
    const { selectOption, isSelected, isExternalSelected, normalizedOptions } = useSelect(
      context,
      modelValue,
      options,
    )

    const selectOptionIfActive = (option) => {
      if (props.disabled) {
        return
      }
      return selectOption(option)
    }
    return {
      selectOptionIfActive,
      isSelected,
      isExternalSelected,
      normalizedOptions,
      ...useFieldValidation(props),
    }
  },
}
</script>
